<template>
  <div class="coupon-list-wrapper">
    <div class="coupon-list-divider" v-if="c2cCouponList.length > 0">
      <div class="inner" :style="{ width: `${progressWidth}%` }"></div>
    </div>
    <div class="coupon-list">
      <div
        class="coupon-list-item"
        v-for="(item, index) in c2cCouponList"
        :key="index"
        v-if="item.couponInfo"
        v-stat.click="{ tag: 'c2c.coupon' }"
        @click="onOpenCouponDetail(item)"
      >
        <div class="coupon-item">
          <img
            v-if="item.showInfo.logoType === ShowLogoType.gif"
            src="../../assets/coupon.gif"
            class="coupon-icon-gif"
          />
          <img
            v-else-if="item.showInfo.logoType === ShowLogoType.png"
            src="../../assets/coupon.png"
            class="coupon-icon"
          />
          <AmountBox class="amount-box" currencyCode="$" size="36" :value="item.couponInfo.discount * 100" :bit="0" />
        </div>
        <div class="coupon-item-bottom">
          <OkIcon
            v-if="item.showInfo.type === ShowType.icon"
            width="24"
            height="24"
            color="#00C553"
            class="bottom-gap"
          ></OkIcon>
          <div v-else-if="item.showInfo.type === ShowType.btn" class="coupon-btn bottom-gap">
            {{ item.showInfo.text }}
          </div>
          <div v-else :style="{ color: item.showInfo.color }" class="bottom-gap-1">{{ item.showInfo.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue-demi';
import { C2CCoupon, ShowLogoType, ShowType } from '../../types';
import { AmountBox } from '@tencent/wphk-ui';
import { OkIcon } from '@tencent/wphk-icon-vue';

const props = defineProps<{
  c2cCouponList: C2CCoupon[];
}>();

const emits = defineEmits(['onOpenCouponDetail']);

/** 第一个可邀请的索引 */
const firstInviteIndex = computed(() => props.c2cCouponList.findIndex(ele => !!ele.isfirstInvite));

/** 进度样式 */
const progressWidth = computed(() => {
  const len = props.c2cCouponList.length;
  let num = 0;
  if (firstInviteIndex.value < 0 || len === firstInviteIndex.value) {
    num = 100;
  } else {
    // 单个券占比
    const singlePercent = 100 / len;
    // 单个券中间占比
    const singleCenterPercent = singlePercent / 2;
    // 定位到第一个可邀请的地方
    num = singlePercent * (firstInviteIndex.value + 1) - singleCenterPercent;
  }
  return num;
});

function onOpenCouponDetail(item: C2CCoupon) {
  emits('onOpenCouponDetail', item);
}
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.coupon-list-wrapper {
  width: 100%;
  position: relative;
  margin: 16 / @rem 0 0 0;
  .coupon-list-divider {
    width: 100%;
    height: 6 / @rem;
    background-color: #caf7dc;
    border-radius: 20 / @rem;
    position: absolute;
    top: 48 / @rem;
    left: 0;
    .inner {
      height: 6 / @rem;
      border-radius: 20 / @rem;
      background-color: @green_01;
    }
  }
}
.coupon-list {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  .coupon-icon {
    width: 72 / @rem;
    height: 80 / @rem;
    object-fit: cover;
  }
  .coupon-icon-gif {
    width: 90 / @rem;
    height: 98 / @rem;
    object-fit: cover;
  }

  .coupon-list-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    .coupon-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100 / @rem;
      position: relative;
      width: 100%;
      .amount-box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: @red;
      }
    }
    .coupon-item-bottom {
      max-width: 95 / @rem;
      text-align: center;
      .font-24-regular(@green_01);
      font-size: 22 / @rem;
      .coupon-btn {
        .font-24-regular(#fff);
        border-radius: 24 / @rem;
        padding: 2 / @rem 12 / @rem;
        background-color: @green_01;
        .en & {
          padding: 2 / @rem 10 / @rem;
          font-size: 20 / @rem;
        }
      }
      .bottom-gap {
        margin-bottom: 30 / @rem;
      }
      .bottom-gap-1 {
        margin-bottom: 8 / @rem;
      }
    }
  }
}
</style>
